import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
//import Tabs from '@mui/material/Tabs';
//import Tab from '@mui/material/Tab';
//import Typography from '@mui/material/Typography';
//import Box from '@mui/material/Box';
//import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

/*
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
*/

const InfoDialog = ({ title, open, onClose, content, buttonText='Close' }) => {

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    onClose();
  };



  return (
    <Dialog onClose={handleClose} open={open} maxWidth={'xs'} fullWidth={true}

    >
      <DialogTitle>
        {title}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent dividers={true}>

        <DialogContentText>
          {content}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" 
        sx={{
            color: '#333330',
            backgroundColor: '#82C027',
            boxShadow: '0px 1px 2px #6F7687',
            borderRadius: '5px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#82C027',
              boxShadow: 'none'
            }
          }}
           onClick={handleClose}>{buttonText}</Button>
      </DialogActions>
    </Dialog>



  );
}


export default InfoDialog;